<template>
  <div class="home">
    <Nav></Nav>

    <Case></Case>
    <DataService></DataService>
    <Solution></Solution>
    <News></News>
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import Solution from "@/components/Solution.vue";
import Case from "@/components/Case.vue";
import DataService from "@/components/DataService.vue";
import News from "@/components/News.vue";

export default {
  name: 'HomeView',

  components: {
    Nav,
    Solution,
    Case,
    DataService,
    News
  }
}
</script>

<style lang="less">

</style>

